import React, {useEffect, useState} from "react";

import '../DashboardWidget.scss'
import './AlarmsOverviewWidget.scss'
import {ContainedList, ContainedListItem, Loading, Tag} from "@carbon/react";
import {useRecoilValue} from "recoil";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import PubSub from "pubsub-js";
import PropTypes from "prop-types";

const AlarmsOverviewWidget = (props) => {
  const cloudConnected = props.cloudConnected
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [graviCount, setGraviCount] = useState(0)
  const [lieviCount, setLieviCount] = useState(0)
  const [infoCount, setInfoCount] = useState(0)
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  const getAlarmsCount = () => {
    const req = new proto.api.GetAlarmsCountRequest()
    alarmsService.getAlarmsCount(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const counts = resp.toObject()
        setGraviCount(counts.alarmsgravi)
        setLieviCount(counts.alarmslievi)
        setInfoCount(counts.alarmsinformativi)
        setError(false)
      }
      setLoading(false)
    })
  }

  const handleAlarmEvent = (msg, data) => {
    getAlarmsCount()
  }

  useEffect(() => {
    getAlarmsCount()
    const token = PubSub.subscribe('ALARM_EVENT', handleAlarmEvent)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [cloudConnected])

  if (loading) {
    return (
      <div className="widget-position-centered-loading">
        <Loading withOverlay={false} />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{paddingLeft: "1rem"}} className="widget-position-centered-loading">
        <span>Non è stato possibile caricare i conteggi</span>
      </div>
    )
  }

  return (
    <ContainedList
      label={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <span>Allarmi aperti</span>
          <Tag size="sm">{graviCount+lieviCount+infoCount}</Tag>
        </div>
      }
      kind="on-page">
      <ContainedListItem key={0}>Gravi: <Tag type="red" size="sm">{graviCount}</Tag></ContainedListItem>
      <ContainedListItem key={1}>Lievi: <Tag type="magenta" size="sm">{lieviCount}</Tag></ContainedListItem>
      <ContainedListItem key={2}>Informativi: <Tag type="blue" size="sm">{infoCount}</Tag></ContainedListItem>
    </ContainedList>
  )
}

AlarmsOverviewWidget.propTypes = {
  cloudConnected: PropTypes.bool.isRequired,
}

export default AlarmsOverviewWidget